import { i18n } from '@/plugins/i18n'

const fields = [
    {
        key: 'name',
        label: i18n.t('campaign.name'),
    },
    {
        key: 'storeName',
        label: i18n.t('store._'),
        policies: {
            campaign: ['view_any_or_group']
        },
    },
    {
        key: 'status',
        label: i18n.t('campaign.status'),
    },
    {
        key: 'cost',
        label: i18n.t('campaign.cost') + '('+i18n.t('rial')+')',
    },
    {
        key: 'goal',
        label: i18n.t('campaign.goal'),
        _style: 'width: 5%;',
    },
    {
        key: 'plan',
        label: i18n.t('campaign.plan'),
        _style: 'width: 5%;',
    },
    {
        key: 'startedAt',
        label: i18n.t('campaign.started_at'),
        _style: 'width: 15%;',
    },
    {
        key: 'finishedAt',
        label: i18n.t('campaign.finished_at'),
        _style: 'width: 15%;',
    },
    {
        key: 'actions',
        label: i18n.t('actions'),
    }
]

export default fields

export const sorts = [
    {
        label: i18n.t('sorter.desc', {attr: i18n.t('attributes.created_at')}),
        value: {
            direction: 'desc',
            column: 'created_at'
        }
    },
    {
        label: i18n.t('sorter.asc', {attr: i18n.t('attributes.created_at')}),
        value: {
            direction: 'asc',
            column: 'created_at'
        }
    },
]